export default __webpack_public_path__ + "static/media/infogray.1eafef47.svg";